window.global ||=  window;


